import { UnitOption } from '@mark43/cad-api';
import { useOpenWorkspacePanel } from '../../panels/use-open-workspace-panel';
import { useSetSelectedUnitHistoryUnitOption } from '../context/hooks';

export function useOpenUnitHistoryPanel(): (unitOption?: UnitOption) => void {
    const openUnitHistoryPanel = useOpenWorkspacePanel();
    const setSelectedUnitHistoryUnitOption = useSetSelectedUnitHistoryUnitOption();
    return (unitOption) => {
        openUnitHistoryPanel({
            workspacePanelConfig: {
                workspacePanelType: 'UNIT_HISTORY',
            },
        });
        if (unitOption) {
            setSelectedUnitHistoryUnitOption(unitOption);
        }
    };
}
